var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnvironment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 0.75C5.28125 0.75 5.6875 1.15625 5.6875 1.5625V6.4375H4.0625V1.5625C4.0625 1.15625 4.41797 0.75 4.875 0.75ZM14.625 0.75C15.0312 0.75 15.4375 1.15625 15.4375 1.5625V6.4375H13.8125V1.5625C13.8125 1.15625 14.168 0.75 14.625 0.75ZM18.6875 8.0625C19.0938 8.0625 19.5 8.46875 19.5 8.875C19.5 9.33203 19.0938 9.6875 18.6875 9.6875H17.875V12.9375C17.875 17.1523 14.625 20.6562 10.5625 21.0625V25.9375C10.5625 26.3945 10.1562 26.75 9.75 26.75C9.29297 26.75 8.9375 26.3945 8.9375 25.9375V21.0625C4.82422 20.6562 1.625 17.1523 1.625 12.9375V9.6875H0.8125C0.355469 9.6875 0 9.33203 0 8.875C0 8.46875 0.355469 8.0625 0.8125 8.0625H18.6875ZM9.75 19.4375C13.3047 19.4375 16.25 16.543 16.25 12.9375V9.6875H3.25V12.9375C3.25 16.543 6.14453 19.4375 9.75 19.4375Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnvironment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/environment.8d22cc49386812b9e393605491813632.svg";